<template>
    <div class="accountBalance" v-loading="loading">
        <div v-if="isShowRegister" class="register">
            <div>您还没开通美的付账户，点击“<span @click="openUrl">去开通</span>”马上注册！</div>
        </div>
        <div v-if="isHasAccount" class="content">
            <span class="label">账户名称：</span>
            <el-select v-model="activeAccount" placeholder="请选择" @change="changeAccount">
                <el-option
                    v-for="item in bankAccountOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
            </el-select>
            <div class="block">
                <div class="left">
                    <div class="balance">
                        <span class="num">{{ balanceData.totalAccountBalance }}<span v-if="balanceData.totalAccountBalance !=='—'">元</span></span>
                        <span class="text">账户总余额</span>
                    </div>
                    <div class="balance">
                        <span class="num">{{ balanceData.availableProjectBalance }}<span v-if="balanceData.totalAccountBalance !=='—'">元</span></span>
                        <span class="text">项目户余额</span>
                    </div>
                    <div class="balance">
                        <span class="num">{{ balanceData.availableCrashBalance }}<span v-if="balanceData.totalAccountBalance !=='—'">元</span></span>
                        <span class="text">一般户余额</span>
                    </div>
                </div>
                <div class="right">
                    <div class="btn">
                        <el-button v-has="'account-balance-recharge'" type="primary" class="bigData-btn-account-balance-recharge" @click="handleBtnClick">充值到一般户</el-button>
                        <el-button v-has="'account-balance-withdraw'" type="primary" class="bigData-btn-account-balance-withdraw" @click="handleBtnClick">去提现</el-button>
                    </div>
                </div>
            </div>
            <p>注：项目户余额冻结不可提现，在司机费用分账支付成功且司机已确认收到后，会释放到一般户中，一般户的余额可提现。</p>
        </div>
    </div>
</template>

<script>
import { mideaPayAccountInfoBalance } from '@/modules/transport/otp/api/driverExpenseUnfreezeAndBalance.js';
import userConfig from '@/config/user.env.js';
import { mapState } from 'vuex';
import bigDataLog from '@/utils/bigDataLog';
export default {
    name: '',
    components: {},
    data() {
        return {
            isHasAccount: false,
            isShowRegister: false,
            loading: false,
            activeAccount: '',
            bankAccountOptions: [],
            balanceData: {}
        };
    },
    computed: {
        ...mapState({
            supplier: state => state.supplier
        })
    },
    methods: {
        // 充值到一般户、去提现均为跳转链接到美的付登陆页面
        handleBtnClick() {
            const url = userConfig.env === 'PROD' ? 'https://mch.mideaepay.com/' : 'https://mch.mideaepayuat.com/';
            window.open(url);
        },
        changeAccount(val) {
            this.activeAccount = val;
            this.balanceData = this.bankAccountOptions.find((item) => item.value === val);
        },
        processBalance(type) {
            return (type === null || type === '' || type === undefined) && type !== 0 ? '—' : type;
        },
        getTotalAccountBalance(balance1, balance2) {
            const newBalance1 = this.processBalance(balance1);
            const newBalance2 = this.processBalance(balance2);
            let balance3 = '—';
            if (newBalance1 === '—' && newBalance2 === '—') {
                balance3 = '—';
            } else if (newBalance1 !== '—' && newBalance2 !== '—') {
                balance3 = (parseFloat(newBalance1) + parseFloat(newBalance2)).toFixed(2);
            } else {
                balance3 = newBalance1 === '—' ? newBalance2 : newBalance1;
            }

            return balance3;
        },
        // 调用SRM接口查询供应商的美的付账号
        syncBtnClick() {
            if (!this.supplier.supplierCode) { return; }
            this.loading = true;
            const params = {
                carrierCode: this.supplier.supplierCode // 供应商编码-LSP
            };
            this.balanceData = {};
            this.bankAccountOptions = [];
            mideaPayAccountInfoBalance(params)
                .then((res) => {
                    if (res && +res.code === 0) {
                        const { data } = res;
                        if (Array.isArray(data) && data.length > 0) {
                            this.bankAccountOptions = data.map(item => {
                                return {
                                    ...item,
                                    value: item.bankAccount,
                                    label: item.bankAccount + ' | ' + item.bankAccountName,
                                    availableProjectBalance: this.processBalance(item.availableProjectBalance),
                                    availableCrashBalance: this.processBalance(item.availableCrashBalance),
                                    totalAccountBalance: this.getTotalAccountBalance(item.availableProjectBalance, item.availableCrashBalance)
                                };
                            });
                            // 默认选中第一个
                            this.activeAccount = this.bankAccountOptions[0].value;
                            this.balanceData = this.bankAccountOptions.find((item) => item.bankAccount === this.activeAccount);
                            this.isHasAccount = true;
                            this.isShowRegister = false;
                        } else {
                            this.isHasAccount = false;
                            this.isShowRegister = true;
                        }
                    }
                })
                .catch(() => { })
                .finally(() => {
                    this.loading = false;
                });
        },
        // 跳转到LSP--工作台--基础信息---银行账户tab页
        openUrl() {
            bigDataLog.sendDetailMessageByKey('bigData-btn-account-balance-register');
            this.$router.push({
                path: '/lsrm/basicInfo',
                query: { tabFinance: 1 }
            });
        }
    },
    mounted() {
        this.syncBtnClick();
    }
};

</script>

<style lang='less' scoped>
.accountBalance {
    height: calc(100vh - 140px);
    background: #fff;
    .register {
        margin: 200px auto 0;
        text-align: center;
        font-size: 24px;
        font-weight: 600;
        span {
            color: #00BCBF;
            cursor: pointer;
        }
    }
    .content {
        font-size: 12px;
        padding: 90px 6.7708vw 0;
        .label {
            font-size: 16px;
            font-weight: 600;
        }
        .el-select {
            width: 260px;
        }
        .block {
            display: flex;
            height: 90px;
            margin: 60px 0 70px;
            font-size: 16px;
            .left {
                width: 40%;
                min-width: 560px;
                display: flex;
                .balance {
                    display: flex;
                    flex-basis: 140px;
                    flex-direction: column;
                    justify-content: space-between;
                    text-align: center;
                    margin-left: 20px;
                    .num {
                        font-size: 20px;
                        font-weight: 600;
                        margin-bottom: 40px;
                        max-width: 190px;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        overflow: hidden;
                    }
                }
                .balance:first-child {
                    margin-left: 0px;
                }
            }
            .right {
                width: 50%;
                min-width: 264px;
                display: flex;
                flex-direction: column;
                justify-content: end;
                .btn {
                    .el-button {
                        width: 122px;
                        font-size: 14px;
                        height: 45px;
                        box-sizing: border-box;
                        letter-spacing: 1px;
                    }
                    .el-button + .el-button {
                        margin-left: 20px;
                    }
                }
            }
        }
        p { padding-left: 28px;}
    }
}
@media (max-width: 1100px) {
    .accountBalance .content {
        padding: 30px 0 0;
        .block .left {min-width: 420px;}
    }
}
</style>